export const objToHash = obj => encodeURIComponent(btoa(JSON.stringify(obj)))

export const hashToObj = hash => JSON.parse(atob(decodeURIComponent(hash)))

export const objToHashAsHash = obj => ({ hash: objToHash(obj) })
